import axios from 'axios'
import { API_BASE_URL } from '../../config/apiConfig'

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')?.replaceAll('"', '')
  return {
    ...(token && { Authorization: `Bearer ${token}` })
  }
}

export const generateClaimInvoice = transactionId => {
  return axios.post(
    `${API_BASE_URL}/claim/${transactionId}/invoice/generate`,
    undefined,
    { headers: getAuthHeaders() }
  )
}

export const generateClaimUcaf = transactionId => {
  return axios.post(
    `${API_BASE_URL}/claim/${transactionId}/ucaf/generate`,
    undefined,
    { headers: getAuthHeaders() }
  )
}
